import type { Informacion } from '../api';

export default function Footer({ info }: { info: Informacion | null }) {
  return (
    <footer className="bg-wine-darker text-white/50 text-center py-8 px-6 text-sm">
      <div className="flex justify-center gap-3 mb-4">
        {info?.facebook_url && (
          <a href={info.facebook_url} target="_blank" rel="noreferrer"
            className="w-9 h-9 rounded-full bg-white/10 hover:bg-gold hover:text-wine-darker flex items-center justify-center transition-colors">f</a>
        )}
        {info?.whatsapp && (
          <a href={`https://wa.me/${info.whatsapp}`} target="_blank" rel="noreferrer"
            className="w-9 h-9 rounded-full bg-white/10 hover:bg-gold hover:text-wine-darker flex items-center justify-center transition-colors">💬</a>
        )}
        {info?.instagram_url && (
          <a href={info.instagram_url} target="_blank" rel="noreferrer"
            className="w-9 h-9 rounded-full bg-white/10 hover:bg-gold hover:text-wine-darker flex items-center justify-center transition-colors">📷</a>
        )}
      </div>
      {info?.nombre_negocio || 'Soda Celes'} © {new Date().getFullYear()} — Sabor de casa, servido con cariño.
    </footer>
  );
}
